<div class="container-fluid">
  <div class="row justify-content-center" style="margin: 25px 0 50px 0;">
    <div class="content col-md-8 col-md-offset-2  col-sm-offset-2 shadowBoxBg">
      <div class="navyCashHeading">Navy Cash&reg;</div>
      <div class="cardHeaderHeading subTitle">Customer Service Handbook
      </div>

      <div class="card card-nc">
        <div class="card-heading">
          <div class="panelHeaderHeading">
            HELP <span class="counter"></span>
          </div>
          <div class="alignRight">
            <div class="rightSearch">
              <input [(ngModel)]="search" type="text" class="searchNavy helpSearchInputBox" placeholder="Search Here"><i
                class="fa fa-search searchOuterBox"></i>
            </div>
          </div>
        </div>

        <div id="searchResultId">
          <div class="search-panel">
            <div *ngFor="let item of helpItems | helpFilter:search; index as i" class="panel panel-nc zeroPadding helpPanel transactionHistText found"
              [id]="item.ID" [class.CurrentViewPanel]="item.ID === activeId">
              <!-- TODO: Add search filter here -->
              <div class="panel-header searchHeader" [class.evenBg]="i % 2 == 0 && item.ID !== activeId" [class.oddBg]="i % 2 == 1 && item.ID !== activeId">
                <div class="searchAnchor" (click)="toggleHelp(item.ID)">{{item.TITLE}}</div>
                <div class="alignRight searchClose" (click)="toggleHelp(item.ID)" [id]="'C' + item.ID" [hidden]="item.ID !== activeId"
                  style="display: block">
                  <div><i class="fa fa-times-circle"></i></div>
                </div>
              </div>
              <div class="panelBodyBox transactionHistText" [id]="'B' + item.ID" [class.CurrentView]="item.ID === activeId"
                [hidden]="item.ID !== activeId" style="display: block">
                <div [innerHTML]="item.DETAIL"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
      <br />
    </div>
  </div>
</div>
